<template>
    <ModalContainer :visible="visible" :loading="loading">
        <template v-slot:header>
            <button type="button" class="close" @click="closeModal"><i class="las la-times"></i></button>
            <h4 class="modal-title">{{ $t('views.reservations.new') }}</h4>
        </template>
        <template v-slot:body>
            <div class="form-group" v-show="errorMessage">
                <div class="alert alert-danger" style="margin: 0 10px;">
                    {{errorMessage}}
                </div>
            </div>
            <AddReservationForm v-if="renderForm" :client-id="clientId" @change="onChangeReservation" :new-reservation-prop="newReservation"></AddReservationForm>
            <div class="form-horizontal margin-top-20"  v-if="newReservation.payment_mode === PAYMENT_MODE.CREDIT_CARD && newReservation.creditCardCheckout">
                <div class="form-group" >
                    <label for="client_credit_card" class="col-xs-4 control-label">{{ $t('common.credit_card') }}</label>
                    <div class="col-xs-8">
                        <StripeElements  ref="elementsRef"
                                         id="client_credit_card"
                                         :pk="STRIPE_PUBLIC_KEY"
                                         :locale="$i18n.locale"
                                         @token="tokenCreated"></StripeElements>
                    </div>
                </div>
                <div class="form-group" v-if="newReservation.payment_mode === PAYMENT_MODE.CREDIT_CARD && newReservation.creditCardCheckout">
                    <label for="price_new_subscription" class="col-xs-4 control-label">{{ $t('common.price') }}</label>
                    <div class="col-xs-8">
                        <p class="form-control-static" id="price_new_subscription">{{getCurrencySymbolFromString(price_currency_credit_card)}}{{price_credit_card}}</p>
                    </div>
                </div>
            </div>
        </template>

        <template v-slot:footer>
            <a class="btn btn-primary btn-lg btn-block"
               v-if="newReservation.payment_mode === PAYMENT_MODE.CREDIT_CARD && !newReservation.creditCardCheckout"
               href=""
               @click.prevent.stop="confirmCreditCardMethod">
                {{ $t('common.next') }}
                <i class="las la-angle-right"></i>
            </a>
            <a class="btn btn-primary btn-lg btn-block"
               href=""
               v-if="newReservation.payment_mode !== PAYMENT_MODE.CREDIT_CARD || newReservation.creditCardCheckout"
               @click.prevent.stop="addNewReservation">
                <i class="las la-check"></i>
                {{ $t('components.reservation.create') }}
            </a>
        </template>
    </ModalContainer>
</template>


<script>
    // TODO improve client detail pass props and if != null don't call api

    import AddReservationForm from "../reservation/AddReservationForm";
    import {createReservation} from "../../api";
    import {PAYMENT_MODE, STRIPE_PUBLIC_KEY} from "../../common/constants";
    import { StripeElements } from 'vue-stripe-checkout';
    import ModalContainer from "./ModalContainer";
    import i18n from '../../i18n'
    import {Utils} from "@/common/utils";

    export default {
        name: "NewReservationModal",
        props: {
            clientId: {
                type: Number,
                default: null
            },
            visible: {
                type: Boolean,
                required: true
            }
        },
        data: () => {
            return {
                price_credit_card: "0.00",
                price_currency_credit_card: "",
                STRIPE_PUBLIC_KEY: STRIPE_PUBLIC_KEY,
                client_secret: "",
                loading: false,
                newReservation: {
                    client: null,
                    rate: null,
                    appointment_set: null,
                    paid_by_subscription: null,
                    payment_mode: null,
                    creditCardCheckout: false,
                    notify: true
                },
                PAYMENT_MODE: PAYMENT_MODE,
                errorMessage: "",
                renderForm: true
            }
        },
        components: {AddReservationForm, ModalContainer, StripeElements},
        computed: {
            creditCardPaymentMode(){
                return PAYMENT_MODE.CREDIT_CARD
            }
        },
        methods: {
            closeModal(){
                this.$emit('close-new-reservation-modal');
                this.renderForm = false;
                this.newReservation = {
                    client: null,
                        rate: null,
                        appointment_set: null,
                        paid_by_subscription: null,
                        payment_mode: null,
                        creditCardCheckout: false,
                        notify: true
                }

                this.$nextTick(() => {
                    this.renderForm = true;
                });
            },
            onChangeReservation(reservation) {
                this.newReservation = reservation;
            },
            async tokenCreated (token) {
                this.loading = true;
                let stripe = window.Stripe(STRIPE_PUBLIC_KEY);

                this.token = token;
                const result = await stripe.confirmCardPayment(this.client_secret, {
                    payment_method: {
                        card: {
                            token: token.id
                        },
                    }
                });


                if (result.error) {
                    if (result.error.type === "card_error") {
                        this.errorMessage = result.error.message
                    }
                } else {

                    if (result.paymentIntent.status === "succeeded") {
                        this.successCreateReservation()
                    }

                }

                this.loading = false;
            },
            async addNewReservation() {
                this.errorMessage = "";
                if (this.newReservation.payment_mode === PAYMENT_MODE.CREDIT_CARD) {
                    this.$refs.elementsRef.submit()
                } else {
                    this.loading = true;
                    try {
                        if (!this.newReservation.appointment_set) {
                            this.errorMessage = i18n.t('components.reservation.select_date');
                            this.loading = false;
                            return;
                        }

                        await createReservation(this.newReservation.client,this.newReservation.rate,
                            this.newReservation.appointment_set.id, this.newReservation.paid_by_subscription,
                            this.newReservation.payment_mode, this.newReservation.notify);
                        this.loading = false;

                        this.successCreateReservation()
                    } catch (e) {
                        this.loading = false;
                        console.log(e)
                    }
                }
            },
            successCreateReservation() {
                this.$emit('success-new-reservation');
                this.$route.params.successMessage = i18n.t('components.reservation.creation_success');
                this.renderForm = false;

                this.$nextTick(() => {
                    this.renderForm = true;
                });
            },
            async confirmCreditCardMethod() {
                this.loading = true;
                try {
                    let response = await createReservation(this.newReservation.client,this.newReservation.rate,
                        this.newReservation.appointment_set.id, this.newReservation.paid_by_subscription,
                        this.newReservation.payment_mode);
                    this.loading = false;
                    this.price_credit_card = response.price_amount;
                    this.price_currency_credit_card = response.price_currency;
                    this.client_secret = response.payment_client_secret;
                    this.newReservation.creditCardCheckout = true;
                } catch (e) {
                    this.loading = false;
                    console.log(e)
                }
            },
            getCurrencySymbolFromString(currency) {
                return Utils.getCurrencySymbolFromString(currency)
            }
        }
    };
</script>